import { c as _c } from "react/compiler-runtime";
import { ContactSlugEnum, CountryEnum, Tooltip, getContactFieldTitle, getSingleCountry, setDateWithTimezone, toISOStringWithoutTimezone, useTranslation as useUiTranslation } from '@systemeio/ui';
import debounce from 'lodash.debounce';
import { ContactId } from 'modules/contacts/types/contact-interface';
import React, { useCallback, useEffect, type JSX } from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { usePhoneInput } from 'shared/react-international-phone';
import { dateFormat } from 'shared/utils/date-time-format';
import { CONTACT_FIELDS_SORT_ORDER } from '../hooks/use-contact-fields';
import { ContactTooltipDataInterface, useContactsTooltipData } from '../hooks/use-contacts-tooltip-data';
interface ContactInfoTooltipProps {
  children?: JSX.Element | string;
  contactId?: ContactId;
  removedAt: string | null;
}
interface LabelTooltipProps {
  contactData: ContactTooltipDataInterface;
  removedAt: string | null;
}
const LabelTooltip = t0 => {
  const $ = _c(39);
  const {
    contactData,
    removedAt
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    t: tUi
  } = useUiTranslation();
  const {
    user
  } = useUser();
  let t1;
  if ($[0] !== contactData.fieldValues) {
    t1 = contactData?.fieldValues.find(_temp)?.value;
    $[0] = contactData.fieldValues;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const phoneNumber = t1;
  let t2;
  if ($[2] !== phoneNumber) {
    t2 = {
      value: phoneNumber
    };
    $[2] = phoneNumber;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    phone: formattedPhoneNumber
  } = usePhoneInput(t2);
  let t3;
  if ($[4] !== formattedPhoneNumber || $[5] !== user?.dashboardLocale) {
    t3 = (slug, value) => {
      switch (slug) {
        case ContactSlugEnum.Country:
          {
            return Object.values(CountryEnum).includes(value as CountryEnum) ? getSingleCountry(value as CountryEnum, user?.dashboardLocale) : value;
          }
        case ContactSlugEnum.PhoneNumber:
          {
            return formattedPhoneNumber;
          }
        default:
          {
            return value;
          }
      }
    };
    $[4] = formattedPhoneNumber;
    $[5] = user?.dashboardLocale;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const getSlugValue = t3;
  let t4;
  if ($[7] !== contactData.referredBy) {
    t4 = contactData?.referredBy && contactData?.referredBy.fieldValues.find(_temp2)?.value;
    $[7] = contactData.referredBy;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const referredEmail = t4;
  let t5;
  let t6;
  if ($[9] !== contactData.fieldValues || $[10] !== getSlugValue || $[11] !== tUi) {
    const sortedFields = [...contactData.fieldValues].sort(_temp3);
    t5 = "text-start flex flex-col items-start gap-2";
    let t7;
    if ($[14] !== getSlugValue || $[15] !== tUi) {
      t7 = el_1 => <p key={el_1.contactField.slug}><span className="text-text-primary font-bold">{getContactFieldTitle(el_1.contactField, tUi)}:{" "}</span><span>{getSlugValue(el_1.contactField.slug as ContactSlugEnum, el_1.value)}</span></p>;
      $[14] = getSlugValue;
      $[15] = tUi;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    t6 = sortedFields.map(t7);
    $[9] = contactData.fieldValues;
    $[10] = getSlugValue;
    $[11] = tUi;
    $[12] = t5;
    $[13] = t6;
  } else {
    t5 = $[12];
    t6 = $[13];
  }
  let t7;
  if ($[17] !== t) {
    t7 = t("dashboard.user.affiliate");
    $[17] = t;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t7) {
    t8 = <span className="text-text-primary font-bold">{t7}: </span>;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== referredEmail || $[22] !== t) {
    t9 = referredEmail || t("global.none");
    $[21] = referredEmail;
    $[22] = t;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t9) {
    t10 = <span>{t9}</span>;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10 || $[27] !== t8) {
    t11 = <p>{t8}{t10}</p>;
    $[26] = t10;
    $[27] = t8;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== removedAt || $[30] !== t || $[31] !== user?.dateFormat || $[32] !== user?.timezone) {
    t12 = removedAt && <p><span className="text-text-primary font-bold">{t("global.contact_removed")}: </span><span>{dateFormat(removedAt, {
          dateFormat: user?.dateFormat,
          timeZone: user?.timezone
        })}</span></p>;
    $[29] = removedAt;
    $[30] = t;
    $[31] = user?.dateFormat;
    $[32] = user?.timezone;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t11 || $[35] !== t12 || $[36] !== t5 || $[37] !== t6) {
    t13 = <div className={t5}>{t6}{t11}{t12}</div>;
    $[34] = t11;
    $[35] = t12;
    $[36] = t5;
    $[37] = t6;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  return t13;
};
const LabelTooltipSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col gap-2"><div className="bg-skeleton-primary w-[250px] animate-pulse rounded-md text-transparent">.</div><div className="bg-skeleton-primary w-[250px] animate-pulse rounded-md text-transparent">.</div><div className="bg-skeleton-primary w-[250px] animate-pulse rounded-md text-transparent">.</div><div className="bg-skeleton-primary w-[250px] animate-pulse rounded-md text-transparent">.</div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const LazyContactInfoTooltip = ({
  children,
  contactId,
  removedAt
}: ContactInfoTooltipProps) => {
  const {
    contactData,
    fetchContactData,
    clearContactData
  } = useContactsTooltipData();
  const fetchContactDataWithDebounce = useCallback(debounce((id: ContactId) => {
    fetchContactData(id);
  }, 500), [fetchContactData]);
  useEffect(() => {
    return () => {
      fetchContactDataWithDebounce.cancel();
    };
  }, [fetchContactDataWithDebounce]);
  const handleMouseEnter = () => {
    if (contactId) {
      fetchContactDataWithDebounce(contactId);
    }
  };
  const handleMouseLeave = () => {
    fetchContactDataWithDebounce.cancel();
    clearContactData();
  };
  const removedAtDateString = removedAt && toISOStringWithoutTimezone(setDateWithTimezone(removedAt, 'UTC')).split('T')[0] + 'T';
  return <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} className="w-full">
      <Tooltip label={contactData ? <LabelTooltip contactData={contactData} removedAt={removedAt} /> : <LabelTooltipSkeleton />} mode="hover" hoverOpenDelay={200} stayOnHover={true} className="w-full max-w-fit truncate" wrapperClassName={'w-full'}>
        {!contactId ? children : <LinkWithoutPrefetch className={'hover:text-text-tertiary/70 truncate underline'} href={removedAt ? `/contacts/bin?order=prev&filter=%5B%7B%22searchValue%22%3A%22${removedAtDateString}00%3A00%3A00%22%2C%22compareOperation%22%3A%22EQUALS%22%2C%22searchField%22%3A%22removed_at%22%7D%5D` : `/contacts/${contactId}`}>
            {children}
          </LinkWithoutPrefetch>}
      </Tooltip>
    </div>;
};
export default LazyContactInfoTooltip;
function _temp(el) {
  return el.contactField.slug === ContactSlugEnum.PhoneNumber;
}
function _temp2(el_0) {
  return el_0.contactField.slug === ContactSlugEnum.Email;
}
function _temp3(a, b) {
  const indexA = CONTACT_FIELDS_SORT_ORDER.indexOf(a.contactField.slug as ContactSlugEnum);
  const indexB = CONTACT_FIELDS_SORT_ORDER.indexOf(b.contactField.slug as ContactSlugEnum);
  if (indexA === -1) {
    return 1;
  }
  if (indexB === -1) {
    return -1;
  }
  return indexA - indexB;
}